module.exports = __webpack_public_path__ + "static/media/gn.41afb65d.svg";